exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/_object-gops.js
// module id = 168
// module chunks = 1